(() => {
  const root = document.querySelector('[data-ad-landing]');
  if (!root) return;
  const quiz = window.MosesQuiz;
  try { quiz?.save({ funnelVariant: root.dataset.funnelVariant }); } catch { /* storage blocked */ }
  quiz?.track('ad_page_view', { funnel_variant: root.dataset.funnelVariant });
  root.querySelectorAll('[data-ad-quiz]').forEach(link => {
    let opening = false;
    link.addEventListener('click', async event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (!quiz) { root.querySelector('[data-ad-error]').hidden = false; return; }
      if (root.dataset.funnelVariant === 'quiz-v2' && !root.dataset.productUrl) {
        const error = root.querySelector('[data-ad-error]');
        error.textContent = 'The new product page is being prepared. Please check back soon.';
        error.hidden = false;
        return;
      }
      if (opening) return;
      opening = true;
      quiz.track('ad_cta_click', { placement: link.dataset.adQuiz, funnel_variant: root.dataset.funnelVariant });
      // Give Shopify's pixel sandbox time to start its keepalive request.
      await new Promise(resolve => setTimeout(resolve, 250));
      quiz.start({ returnUrl: root.dataset.productUrl || quiz.config.productUrl, emailGate: root.dataset.funnelVariant !== 'quiz-v2', url: link.href });
    });
  });
})();
